module.exports = __webpack_public_path__ + "static/media/icon-linkedin.52f50808.svg";